<template>
  <w-flex v-if="needAutosave != undefined" id="autosaveinfo" class="autosave-info" :gap="2">
    <span class="autosave-info__label"> Ostatni zapis: </span>

    <w-flex v-if="needAutosave" align="center" class="color-caution-300" :gap="1">
      <w-icon size="sm" icon="warning" />

      Brak
    </w-flex>

    <w-flex v-else align="center" class="color-success-200" :gap="1">
      <w-icon size="sm" icon="check" />

      Aktualny
    </w-flex>
  </w-flex>
</template>

<script setup lang="ts">
defineProps<{
  needAutosave?: boolean;
}>();

defineEmits({
  'prev-clicked': null,
  'next-clicked': null,
  cancel: null,
  save: null,
  'change-tab': null,
});
</script>

<style lang="scss">
.autosave-info {
  font-size: w.font('small');
  color: w.color('neutral', 200);
}
</style>
